import { useEffect, useState } from 'react';
import { adminApi } from '../../adminApi';
import { IconFileText } from '../../components/Icon';
import { AdminHeader } from './ui';

export default function AdminLogs() {
  const [tab,setTab]=useState<'debug'|'live'|'testers'>('debug');
  const [files,setFiles]=useState<any[]>([]); const [tail,setTail]=useState(''); const [selected,setSelected]=useState<string>('');
  const [live,setLive]=useState<any[]>([]); const [liveContent,setLiveContent]=useState(''); const [liveFile,setLiveFile]=useState('');
  const [testers,setTesters]=useState<any[]>([]); const [filter,setFilter]=useState('');

  const loadDebug=()=> adminApi.debugLogs().then(r=>{ if(r.status===200) setFiles(r.data?.files||[]); });
  const loadLive=()=> adminApi.liveSessions({filter:'all'}).then(r=>{ if(r.status===200) setLive(r.data?.sessions||[]); });
  const loadTesters=()=> adminApi.testerLogs().then(r=>{ if(r.status===200) setTesters(r.data?.logs||r.data?.app_logs||[]); });

  useEffect(()=>{ if(tab==='debug') loadDebug(); if(tab==='live') loadLive(); if(tab==='testers') loadTesters(); },[tab]);

  const tailFetch=async(f:string,src:string)=>{ setSelected(f); const r=await adminApi.debugTail({file:f,source:src,filter}); if(r.status===200) setTail(r.data?.content||''); };

  return (
    <div>
      <AdminHeader icon={IconFileText} title="Logs" subtitle="Debug files, live sessions, and tester app logs." />
      <div className="flex gap-4">
        {(['debug','live','testers'] as const).map(t=>(
          <button key={t} onClick={()=>setTab(t)} className={`px-4 py-4 rounded-xl text-sm capitalize ${tab===t?'bg-[color:var(--color-brand)] text-white':'bg-white/5 border border-white/10'}`}>{t}</button>
        ))}
      </div>

      {tab==='debug' && (
        <div className="grid gap-6 lg:grid-cols-[320px_1fr] mt-6">
          <div className="glass p-6">
            <div className="flex items-center justify-between"><h3 className="font-bold">Files</h3><button onClick={loadDebug} className="text-xs text-[color:var(--color-brand-glow)]">Refresh</button></div>
            <input value={filter} onChange={e=>setFilter(e.target.value)} placeholder="Regex filter" className="mt-3 w-full rounded-xl bg-black/30 border border-[color:var(--color-line)] px-3 py-2 text-xs" />
            <div className="mt-3 space-y-1 max-h-[520px] overflow-y-auto">
              {files.map((f:any)=><button key={f.file} onClick={()=>tailFetch(f.file,f.source)} className={`w-full text-left px-3 py-2 rounded-xl text-xs ${selected===f.file?'bg-[color:var(--color-brand)]/15 border border-[color:var(--color-brand)]/30':'bg-white/[0.02] border border-white/5 hover:bg-white/[0.05]'}`}>
                <div className="font-mono truncate">{f.file}</div><div className="text-[10px] text-[color:var(--color-ink-faint)]">{f.source} · {(f.size/1024).toFixed(1)} KB</div>
              </button>)}
              {files.length===0 && <div className="text-xs text-[color:var(--color-ink-faint)] py-8 text-center">No logs</div>}
            </div>
          </div>
          <div className="glass p-6">
            <div className="flex items-center justify-between"><h3 className="font-bold">Tail (256KB)</h3><div className="text-xs text-[color:var(--color-ink-faint)]">{selected||'Select a file'}</div></div>
            <pre className="mt-3 bg-black/40 rounded-xl p-4 text-xs font-mono overflow-auto max-h-[520px] whitespace-pre-wrap">{tail||'—'}</pre>
          </div>
        </div>
      )}

      {tab==='live' && (
        <div className="grid gap-6 lg:grid-cols-[320px_1fr] mt-6">
          <div className="glass p-6">
            <h3 className="font-bold">Sessions</h3>
            <div className="mt-3 space-y-1 max-h-[520px] overflow-y-auto">
              {live.map((s:any)=><button key={s.file} onClick={async()=>{ setLiveFile(s.file); const r=await adminApi.liveContent({file:s.file}); if(r.status===200) setLiveContent(r.data?.content||''); }} className={`w-full text-left px-3 py-2 rounded-xl text-xs ${liveFile===s.file?'bg-[color:var(--color-brand)]/15 border border-[color:var(--color-brand)]/30':'bg-white/[0.02] border border-white/5'}`}>
                <div className="flex items-center gap-2"><span className={`w-1.5 h-1.5 rounded-full ${s.is_live?'bg-[color:var(--color-ok)] animate-pulse':'bg-[color:var(--color-ink-faint)]'}`} />{s.user} {s.is_tester&&<span className="chip !text-[9px]">tester</span>}</div>
                <div className="font-mono truncate">{s.file}</div><div className="text-[10px] text-[color:var(--color-ink-faint)]">{(s.size/1024).toFixed(1)} KB · {s.ago}</div>
              </button>)}
              {live.length===0 && <div className="text-xs text-[color:var(--color-ink-faint)] py-8 text-center">No live sessions</div>}
            </div>
          </div>
          <div className="glass p-6">
            <h3 className="font-bold">Stream {liveFile}</h3>
            <pre className="mt-3 bg-black/40 rounded-xl p-4 text-xs font-mono overflow-auto max-h-[520px] whitespace-pre-wrap">{liveContent||'Select a session'}</pre>
          </div>
        </div>
      )}

      {tab==='testers' && (
        <div className="glass p-6 mt-6">
          <h3 className="font-bold">Tester logs (last 100)</h3>
          <div className="mt-3 space-y-2 max-h-[600px] overflow-y-auto">
            {testers.map((t:any,i:number)=><div key={i} className="p-3 rounded-xl bg-white/[0.02] border border-white/5"><div className="text-xs text-[color:var(--color-ink-faint)]">#{t.user_id} · {String(t.created_at).slice(0,16)}</div><pre className="text-xs font-mono whitespace-pre-wrap">{t.log_line||t.log_data||JSON.stringify(t).slice(0,300)}</pre></div>)}
            {testers.length===0 && <div className="text-sm text-[color:var(--color-ink-faint)] py-8 text-center">No tester logs</div>}
          </div>
        </div>
      )}
    </div>
  );
}
